import React from "react";
import ContentCard from "../../../../UI/ContentCard/ContentCard";

import fitImg from "../../../../assests/images/fit.png";

const VisionPerfectFit = () => (
  <ContentCard
    title="The Perfect Fit"
    id="perfectFit"
    image={fitImg}
    imageTitle="The Perfect Fit"
    frontText="We believe a garment is only worth its price when it fits the individual body."
    backTextOne="  Often enough you need to try two or three sizes until you find a garment that fits.
        And even then it might not fit perfectly. We find it annoying, that size references are not reliable."
    backTextTwo="We want to change that by assuring a perfect fit.  We came up with a new size system that acknowledges that there are different
    body proportions. So we will offer the perfect cut in the proper combination of body length, body width and sleeve length."
  />
);

export default VisionPerfectFit;



// WEBPACK FOOTER //
// ./src/components/Pages/Vision/Content/VisionPerfectFit.js